import { KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum, UIDAStructureTypeEnum } from '@kaltura-ott/tvpil';
import { container } from 'tsyringe';

import { assertPresence } from '../../../utils/error-handling';
import { AppParametersStore } from '../../app/app-params-store';

import { DenyList, denyListToLowerCase, isDenyDevice } from './player-service';

export class PlayerStore {
  static moduleName = 'PlayerStore';
  public type: UIDAStructureTypeEnum.widget = UIDAStructureTypeEnum.widget;
  public subtype: UIDAPresentationTypeEnum.player = UIDAPresentationTypeEnum.player;

  public defaultAudioCodes: string[] = [];
  public defaultSubtitlesCodes: string[] = [];
  public epgButtonEnabled: boolean;
  public hevcDenyList: DenyList = {};
  public drmDenyList: DenyList = {};
  public drmCapable: boolean;
  public hevcCapable: boolean;
  public hevcErrorsFallbackLimitation: number;

  public zapperDisplayEnabled: boolean;
  public seekWithThumbnailsDenialList: string[] = [];
  public isSeekWithThumbnailsEnabled: boolean;

  public isIdleMessageEnabled: boolean;
  public isIdleMessageManagementEnabled: boolean;
  public idleMessageLifecycle: number;
  public idleMessageDuration: number;

  public playerOneClickMove: number;
  public connectivityTimeoutBuffer: number;
  public keepAliveBeaconsFrequency: number;

  constructor(playerTree: KuxFilteredCategoriesDTO) {
    this.defaultAudioCodes = playerTree.player.defaultAudioCodes ? playerTree.player.defaultAudioCodes.split(',') : [];

    this.defaultSubtitlesCodes = playerTree.player.defaultSubtitlesCodes
      ? playerTree.player.defaultSubtitlesCodes.split(',')
      : [];
    // @ts-expect-error TODO Fix
    this.zapperDisplayEnabled = playerTree.player.zapperDisplayEnabled;

    try {
      this.hevcDenyList = denyListToLowerCase(
        playerTree.player.hevcDenyList ? JSON.parse(playerTree.player.hevcDenyList) : {},
      );
    } catch (e) {
      this.hevcDenyList = {};
    }

    try {
      this.drmDenyList = denyListToLowerCase(
        playerTree.player.drmDenyList ? JSON.parse(playerTree.player.drmDenyList) : {},
      );
    } catch (e) {
      this.drmDenyList = {};
    }

    // @ts-expect-error TODO Fix
    this.drmCapable = playerTree.player.drmCapable;
    // @ts-expect-error TODO Fix
    this.hevcCapable = playerTree.player.hevcCapable;
    // @ts-expect-error TODO Fix
    this.hevcErrorsFallbackLimitation = playerTree.player.hevcErrorsFallbackLimitation;
    const appParametersStore = container.resolve<AppParametersStore>('appParamsStore');
    const currentDeviceBrand = assertPresence(appParametersStore.currentDevice.brandId).toString();
    this.seekWithThumbnailsDenialList = playerTree.player.seekWithThumbnailsDenialList;
    this.isSeekWithThumbnailsEnabled = !playerTree.player.seekWithThumbnailsDenialList.includes(currentDeviceBrand);
    this.isIdleMessageEnabled = playerTree.player.isIdleMessageEnabled;
    this.isIdleMessageManagementEnabled = playerTree.player.isIdleMessageManagementEnabled;
    this.idleMessageLifecycle = playerTree.player.idleMessageLifecycle;
    this.idleMessageDuration = playerTree.player.idleMessageDuration;
    this.playerOneClickMove = playerTree.player.playerOneClickMove;
    this.connectivityTimeoutBuffer = playerTree.player.connectivityTimeoutBuffer;
    this.keepAliveBeaconsFrequency = playerTree.player.keepAliveBeaconsFrequency;
    this.epgButtonEnabled = playerTree.player.epgButtonEnabled;
  }

  public get isHevcDeny() {
    const appParamsStore = container.resolve<AppParametersStore>('appParamsStore');
    // @ts-expect-error TODO Fix
    return isDenyDevice(appParamsStore.params.deviceAttributes, this.hevcDenyList);
  }

  public get isDrmDeny() {
    const appParamsStore = container.resolve<AppParametersStore>('appParamsStore');
    // @ts-expect-error TODO Fix
    return isDenyDevice(appParamsStore.params.deviceAttributes, this.drmDenyList);
  }
}
